// Cliente de /api/sala (Sala de Control de Calypso).
import { api } from '../../../lib/api';
import type { CuentaSala, FotoRinconSala, GastoSala, NombreFotoSala, PulsoSala, RangoModelosSala, RangoSala } from './tipos';

export const salaApi = {
  pulso: () => api<PulsoSala>('/api/sala/pulso'),
  rango: (desde: string, hasta: string) => api<RangoSala>(`/api/sala/pulso/rango?desde=${desde}&hasta=${hasta}`),
  rangoModelos: (desde: string, hasta: string) => api<RangoModelosSala>(`/api/sala/modelos/rango?desde=${desde}&hasta=${hasta}`),
  rincon: <T>(nombre: NombreFotoSala, ya = false) => api<FotoRinconSala<T>>(`/api/sala/${nombre}${ya ? '?ya=1' : ''}`),
  gasto: (desde: string, hasta: string) => api<GastoSala>(`/api/sala/gasto?desde=${desde}&hasta=${hasta}`),
  buscarCuentas: (q: string) => api<{ cuentas: CuentaSala[] }>(`/api/sala/cuentas/buscar?q=${encodeURIComponent(q)}`),
};
